/*
 * @Project_description: 注册组件
 */
'use strict'
import NavMenu from "./NavMenu/index.vue"
import kwInputTree from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import AMap from "@/components/AMap/index.vue";
import ECharts from "@/components/ECharts/index.vue";
import inputMap from "@/components/inputMap/index.vue";
import Swiper from "@/components/Swiper/index.vue";
import Tabs from "@/components/tabs/index.vue";
import Vhtml from "@/components/Vhtml/index.vue";
import KwText from "@/components/text/index.vue";
import KwInput from '@/components/input/index.vue'
import KwSelect from '@/components/select/index.vue'
import KwDropDown from '@/components/dropdown/index.vue'
import KwQrCode from '@/components/qrCode/index.vue'

export default (Vue) => {
    Vue.component('i-nav-menu', NavMenu);
    Vue.component('kw-input-tree', kwInputTree);
    Vue.component('AMap', AMap);
    Vue.component('ECharts', ECharts);
    Vue.component('inputMap', inputMap);
    Vue.component('kw-swiper', Swiper);
    Vue.component('kw-tabs', Tabs);
    Vue.component('kw-vhtml', Vhtml);
    Vue.component('kw-text', KwText);
    Vue.component('kw-input', KwInput);
    Vue.component('kw-select', KwSelect);
    Vue.component('kw-drop-down', KwDropDown);
    Vue.component('kw-qrCode', KwQrCode);
}
